import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Sessions } from 'src/app/libraries/sessions';
import { IReturn } from 'src/app/libraries/ireturn';
import { APP_BASE_HREF } from '@angular/common';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ModulosService {

  constructor(private http: HttpClient,  @Inject(APP_BASE_HREF) private baseUrl: string) { }

  index(data : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Modulos/Index", data, Sessions.header());
  }

  store(data : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Modulos/Store", data, Sessions.header());
  }

  edit(data : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Modulos/Edit", data, Sessions.header());
  }

  update(data : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Modulos/Update", data, Sessions.header());
  }

  updateOrden(data : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Modulos/UpdateOrden", data, Sessions.header());
  }

  delete(data : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Modulos/Delete", data, Sessions.header());
  }

}